module.exports = __webpack_public_path__ + "img/select_ic.4e45ba85.png";